import {
	Classifier,
	CreateClassifierRequestProps,
	UpdateClassifierRequestProps,
} from '@dealstack/frontend/app/pages/Project/DealSettings/Classifiers/types';
import {
	CreateDealClassifierDto,
	DealClassifierTct,
	UpdateDealClassifierDto,
} from '@dealstack/shared/lib/generated';
import { isEmpty } from 'lodash';
import { SearchSelectWithNestedCollapsableChildrenOptions } from '@dealstack/frontend/shared/components/forms/SearchSelectWithNestedCollapsableChildren/SearchSelectWithNestedCollapsableChildren.types';

export const isNewClassifier = (classifier: Classifier) => !classifier.dealClassifierId;

export const createNewClassifier = (dealId?: string): Classifier => {
	return {
		dealId,
		name: '',
		classifierParentId: null,
		archive: false,
	};
};

export function createClassifiersOptions(
	classifiers: DealClassifierTct[] = [],
	currentClassifier?: Classifier
): SearchSelectWithNestedCollapsableChildrenOptions[] {
	// filter out classifications
	const filteredClassifications = classifiers.filter(
		(classifier) =>
			// Exclude the current classifier from being selected as its own parent
			classifier.classifierId !== currentClassifier?.classifierId &&
			// Only include root-level classifiers (those without a parent)
			!classifier.classifierParentId
	);
	const mappedOptions = filteredClassifications.map((classifier) => ({
		value: classifier.classifierId,
		label: classifier.name,
	}));

	// add none as an option
	const optionsWithDefault = [{ value: '', label: 'None' }, ...mappedOptions];

	return optionsWithDefault;
}

type BuildUpdateDataProps = {
	formValues: UpdateDealClassifierDto;
	dealId: string;
	classifier: Classifier;
};
export const buildUpdateData = ({
	formValues,
	dealId,
	classifier,
}: BuildUpdateDataProps): UpdateClassifierRequestProps => {
	const classifierParentId = !isEmpty(formValues.classifierParentId)
		? formValues.classifierParentId
		: null;

	return {
		...formValues,
		dealId,
		classifierParentId,
		dealClassifierId: classifier.dealClassifierId ?? '',
	};
};

type BuildCreateDataProps = {
	formValues: CreateDealClassifierDto;
	dealId: string;
};
export const buildCreateData = ({
	formValues,
	dealId,
}: BuildCreateDataProps): CreateClassifierRequestProps => {
	const classifierParentId = !isEmpty(formValues.classifierParentId)
		? formValues.classifierParentId
		: null;

	return {
		...formValues,
		classifierParentId,
		dealId,
	};
};
